
import React, { useRef } from 'react';
import { maxWidth, retina, secondaryFont, wMBold } from 'constants/utilsStyles';
import styled from 'styled-components';
import { DEFAULT_CAMPAIGN_IMAGE } from "../../../constants/types";
import { getPersonImageUrl } from 'utils';

const ListCardPhotoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 180px;
  width: 100%;
  @media all and (max-width: ${maxWidth}), ${retina} {
    height: 150px;
  }
   .heroImageWrap {
    height: 65%;
    .hero-image {
      object-fit:cover;
      border-top-right-radius: 13px;
      border-top-left-radius: 13px;
    }
   }
   .digestTileImage {
    position: relative;
    display: inline-flex;
    flex-direction: row;
    height: 35%;
    width: 100%;
    img {
      width: 33.3%;
      object-fit:cover;
    }
    .digest-image {
      border-bottom: none;
      border-right: 1px solid #fff;
      border-left: 1px solid #fff;
    }
    .count-div {
      position: absolute;
      background-color: rgba(98, 98, 98, 0.503524);
      height: calc(100% - 0px);
      width: 33.33%;
      display: flex;
      justify-content: center;
      align-items: center;
      right: 0px;
      bottom: 0px;
      font-family: ${secondaryFont};
      font-weight: ${wMBold};
      font-size: 25px;
      line-height: 28px;
      color: #fff;
      backdrop-filter: blur(2px);
      @media all and (max-width: ${maxWidth}), ${retina} {
        font-size: 22px;
      }
    } 
   }
`;

const ImageHero = styled.img`
  border-bottom: 2px solid #fff;
  height: 100%;
  width: 100%;
`;

const TileCardPhotoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 70px;
  width: 80px;
  min-width: 80px;
  .first-layer {
    height: 50%;
    display: flex;
    flex-direction: row;
    img {
      width: 50%;
      &:nth-child(1) {
        border-top-left-radius: 8px;
        border-right: 1px solid #fff;
      }
      &:nth-child(2) {
        border-top-right-radius: 8px;
        border-left: 1px solid #fff;
      }
    }
  }
  .second-layer {
    height: 50%;
    display: flex;
    flex-direction: row;
    img {
      width: 50%;
      &:nth-child(1) {
        border-bottom-left-radius: 8px;
        border-right: 1px solid #fff;
      }
      &:nth-child(2) {
        border-bottom-right-radius: 8px;
        border-left: 1px solid #fff;
      }
    }
  }
`;


type Props = {
  listView?: boolean,
  topContactsThumbnails: string[],
  topContactsPersonIds: number[],
  totalContacts: number,
} & typeof defaultProps;

const defaultProps = {
  listView: false,
};

const ListCardPhotoAlbum = function ListCardPhotoAlbum(props: Props) {
  const { listView, topContactsThumbnails, topContactsPersonIds, totalContacts } = props;
  // const imgUrl = 'https://s3-us-west-2.amazonaws.com/xiqapp-static/Persons/sajjadkhan85.jpg';
  const count = totalContacts > 4 ? totalContacts - topContactsThumbnails.length : null;
  // console.info(topContactsThumbnails);
  const newTopContactsThumbnails = [...topContactsThumbnails];
  const tileImageRef = useRef<HTMLDivElement>(null);
  const tileImageWidth = tileImageRef?.current?.clientWidth / 2;
  const heroImageRef = useRef<HTMLDivElement>(null);
  const digestImageRef = useRef<HTMLDivElement>(null);
  const digestImageWidth = digestImageRef?.current?.clientWidth / 3;

  return (
    <>
      {listView ? (
        <TileCardPhotoWrapper>
          <div className='first-layer' ref={tileImageRef}>
            {newTopContactsThumbnails?.splice(2).map((img, index) => (
              <ImageHero src={getPersonImageUrl(img ?? DEFAULT_CAMPAIGN_IMAGE,
                tileImageWidth || 40,
                tileImageRef?.current?.clientHeight || 34, topContactsPersonIds[index]) ?? DEFAULT_CAMPAIGN_IMAGE} alt="heroArticle" className='hero-image' />
            ))}
          </div>
          <div className='second-layer'>
            {newTopContactsThumbnails?.splice(0, 2).map((img, index) => (
              <ImageHero src={getPersonImageUrl(img ?? DEFAULT_CAMPAIGN_IMAGE,
                tileImageWidth || 40,
                tileImageRef?.current?.clientHeight || 34, topContactsPersonIds[index + 2]) ?? DEFAULT_CAMPAIGN_IMAGE} alt="heroArticle" className='digest-image' />
            ))}
          </div>
        </TileCardPhotoWrapper >
      ) : (
        <ListCardPhotoWrapper className='list-card-photo-album'>
          <div className="heroImageWrap" ref={heroImageRef}>
            <ImageHero src={getPersonImageUrl(newTopContactsThumbnails[0] ?? DEFAULT_CAMPAIGN_IMAGE,
              heroImageRef?.current?.clientWidth || 249,
              heroImageRef?.current?.clientHeight || 135,
              topContactsPersonIds[0],
            ) ?? DEFAULT_CAMPAIGN_IMAGE} alt="heroArticle" className='hero-image' />
          </div>
          <div className="digestTileImage" ref={digestImageRef}>
            {newTopContactsThumbnails?.splice(1, 4).map((imgUrl, index) => (
              <ImageHero src={getPersonImageUrl(imgUrl ?? DEFAULT_CAMPAIGN_IMAGE,
                digestImageWidth || 175,
                digestImageRef?.current?.clientHeight || 135, topContactsPersonIds[index + 1],) ?? DEFAULT_CAMPAIGN_IMAGE} alt="heroArticle" className='digest-image' />
            ))}
            {count && <span className='count-div'>+ {count}</span>}
          </div>
        </ListCardPhotoWrapper>
      )}
    </>
  );
};
export default ListCardPhotoAlbum;